module.exports = __webpack_public_path__ + "static/media/giftsReceived_1000_2000.d22ecacf.png";